import { Filter } from '@tamagui/lucide-icons';
import { HeaderIcon } from '@unistocks/components/modal/header-icon';
import { HeaderButton } from '@unistocks/components/page/header/header-button/header-button';
import { Sheet } from '@unistocks/components/sheet/sheet';
import { AssetFilter } from '@unistocks/features/admin/components/asset-management/asset-filter';
import { AssetFilterForm } from '@unistocks/features/admin/components/asset-management/asset-filter-form';
import { AdminActions, selectAssetFilter } from '@unistocks/features/admin/store/admin.slice';
import { useAppDispatch, useAppSelector } from '@unistocks/shared/hooks/redux-hooks';
import { useToggle } from '@unistocks/shared/hooks/use-toggle';
import { t } from '@unistocks/shared/localization/index.ts';
import { isEmpty } from '@unistocks/shared/utils/util';
import { getVariableValue } from 'tamagui';

export const AssetFilterSheet: React.FC = () => {
  const dispatch = useAppDispatch();
  const filter = useAppSelector(selectAssetFilter);
  const [showFilter, toggleFilter, setShowFilter] = useToggle(false);
  const padding = getVariableValue('$3', 'space');

  const badge = Object.entries(filter).filter(([key, value]) => {
    switch (key as keyof AssetFilter) {
      case 'assetType':
      case 'dataSource':
        return !isEmpty(value);

      default:
        return false;
    }
  }).length;

  const updateFilter = (newFilter: AssetFilter) => {
    dispatch(AdminActions.setAssetFilter({ ...newFilter, page: 1 }));
    setShowFilter(false);
  };

  return (
    <>
      <HeaderButton Icon={Filter} badge={badge} onPress={toggleFilter} />

      <Sheet
        open={showFilter}
        onOpenChange={setShowFilter}
        enableDynamicSizing
        scrollViewProps={{ contentContainerStyle: { paddingTop: padding } }}
        headerTitle={t('::Assets:Filter')}
        headerIcon={<HeaderIcon Icon={Filter} />}
      >
        <AssetFilterForm initialValues={filter} onSubmit={updateFilter} />
      </Sheet>
    </>
  );
};

AssetFilterSheet.displayName = 'AssetFilterSheet';
